export default __webpack_public_path__ + "static/media/naidi-1-4.801cd134.svg";